export enum ExternalLinksTypes {
  'oneToOne' = '1-to-1',
  'evaluation' = 'evaluation',
  'pdp' = 'pdp',
  'engineeringManagerNotes' = 'engineeringManagerNotes',
  'cv' = 'cv',
  'pip' = 'pip',
  'peerInterviewResultsLink' = 'peerInterviewResultsLink',
}
